import { render } from "./HorseEditMainOtherData.vue?vue&type=template&id=6f57b2ec"
import script from "./HorseEditMainOtherData.vue?vue&type=script&lang=js"
export * from "./HorseEditMainOtherData.vue?vue&type=script&lang=js"

import "./HorseEditMainOtherData.vue?vue&type=style&index=0&id=6f57b2ec&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__